import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ApiError } from "./services";
import "./styles/index.css";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			// Auth and authorization failures are terminal — retrying a 403 just
			// makes the user wait longer for the same answer.
			retry: (count, err) =>
				err instanceof ApiError && (err.isUnauthorized || err.isForbidden)
					? false
					: count < 2,
			staleTime: 30_000,
		},
	},
});

// biome-ignore lint/style/noNonNullAssertion: #root is in index.html
ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</QueryClientProvider>
	</React.StrictMode>,
);
